import Angular from 'angular';
import Loader from 'angular-ecmascript/module-loader';
import {Provider} from "angular-ecmascript/module-helpers";
import Settings from "../model/settings.model";

class SettingsProvider extends Provider {
    static $name = 'settings';

    $get() {
        return Settings.load();
    }
}

var SettingsModule = Angular.module('settings-provider', []);

new Loader(SettingsModule)
    .load(SettingsProvider);

export default SettingsModule;



// WEBPACK FOOTER //
// ./src/modules/main/providers/settings.provider.js